// extracted by mini-css-extract-plugin
export var dropdown = "_tp-0";
export var imageWrapper = "_tp-3";
export var itemNameContainer = "_tp-1";
export var productImage = "_tp-2";
export var spinnerWrapper = "_tp-4";